import { render } from "./UserEditCompanyInformation.vue?vue&type=template&id=6a4b5bc4"
import script from "./UserEditCompanyInformation.vue?vue&type=script&lang=js"
export * from "./UserEditCompanyInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__